import { createApi } from '@reduxjs/toolkit/query/react'

import StorageKeys from 'src/core/classes/cache/StorageKeys'
import { ICountry } from 'src/core/classes/models/IReference'

import { getProcedureUrl } from './helpers/getBaseUrl'
import { getCustomQuery } from './helpers/getCustomQuery'
import { getResponseHandler } from './helpers/getResponseHandler'

export const referenceCountriesApi = createApi({
  reducerPath: '@app/api/referenceCountries',
  baseQuery: getCustomQuery({
    storageKey: StorageKeys.countries,
    baseUrl: getProcedureUrl('spApp_getCountries'),
  }),
  endpoints: (builder) => ({
    getReferenceCountries: builder.query<ICountry[], void>({
      query: () => {
        return {
          url: ``,
          method: 'POST',
          responseHandler: getResponseHandler({
            storageKey: StorageKeys.countries,
          }),
        }
      },
    }),
  }),
})

export const { useGetReferenceCountriesQuery } = referenceCountriesApi
